import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProjectService } from '../../services/project.service';
import { Card } from "primeng/card";
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { PermissionService } from '../../core/services/permission.service';
import { ProjectRole } from '../../core/constants/roles.constant';

@Component({
  selector: 'app-blockschedulebulkupdate',
  imports: [CommonModule, MultiSelectModule, ButtonModule, FileUploadModule, FormsModule, Card],
  templateUrl: './blockschedulebulkupdate.html',
  styleUrl: './blockschedulebulkupdate.css',
})
export class Blockschedulebulkupdate {
  private readonly integratorHiddenFields = new Set<string>([
    'shipDate',
    'arrivalDate',
    'skidConfiguration',
    'billoflading',
    'appointmentTime',
    'overWeight',
    'overDimension',
    'logisticsComment',
    'deliveryDate',
    'shippingStatus',
    'estimatedDeliveryDate'
  ]);
  fileSelected: File | null = null;
  projectId: number = 0;
  private readonly tmeicSkidField = { 'title': 'TMEIC MVPS # ', 'field': 'skidNo' };
  public selectedItems: any[] = [this.tmeicSkidField];
  private readonly allDataFields: any[] = [
    this.tmeicSkidField,
    { 'title': 'Shipping Date', 'field': 'shipDate' },
    { 'title': 'Arrival Date', 'field': 'arrivalDate' },
    { 'title': 'Integrator MVPS #', 'field': 'skidSerialNo' },
    { 'title': 'Customer MVPS #', 'field': 'customerSkidNumber' },
    { 'title': 'MVPS Configuration', 'field': 'skidConfiguration' },
    { 'title': 'Bill of lading', 'field': 'billoflading' },
    { 'title': 'Appointment Time', 'field': 'appointmentTime' },
    { 'title': 'Over Weight', 'field': 'overWeight' },
    { 'title': 'Over Dimension', 'field': 'overDimension' },
    { 'title': 'Logistics Comment', 'field': 'logisticsComment' },
    { 'title': 'Delivery Date', 'field': 'deliveryDate' },
    { 'title': 'Shipping Status', 'field': 'shippingStatus' },
    { 'title': 'Inverter 1 Serial No', 'field': 'inv1SerialNo' },
    { 'title': 'Inverter 2 Serial No', 'field': 'inv2SerialNo' },
    { 'title': 'Inverter 3 Serial No', 'field': 'inv3SerialNo' },
    { 'title': 'Inverter 4 Serial No', 'field': 'inv4SerialNo' },
    { 'title': 'Inverter 5 Serial No', 'field': 'inv5SerialNo' },
    { 'title': 'Inverter 6 Serial No', 'field': 'inv6SerialNo' },
    { ' title': 'Inverter 7 Serial No', 'field': 'inv7SerialNo' },
    { 'title': 'Inverter 1 IGBT', 'field': 'inv1Igbt' },
    { 'title': 'Inverter 2 IGBT', 'field': 'inv2Igbt' },
    { 'title': 'Inverter 3 IGBT', 'field': 'inv3Igbt' },
    { 'title': 'Inverter 4 IGBT', 'field': 'inv4Igbt' },
    { 'title': 'Inverter 5 IGBT', 'field': 'inv5Igbt' },
    { 'title': 'Inverter 6 IGBT', 'field': 'inv6Igbt' },
    { 'title': 'Inverter 7 IGBT', 'field': 'inv7Igbt' },
    { 'title': 'SCU Installed?', 'field': 'scu' },
    { 'title': 'DIS Installed?', 'field': 'dis' },
    { 'title': 'EPANB Installed?', 'field': 'epanb' },
    { 'title': 'DC Fuses Installed?', 'field': 'dcFuses' },
    { 'title': 'Estimated Delivery Date', 'field': 'estimatedDeliveryDate' },
    { 'title': 'MV Xfmr Design', 'field': 'mvXfmrDesign' },
    { 'title': 'MV Xfmr #', 'field': 'mvXfmrSerialNo' },
    { 'title': 'LV Xfmr #', 'field': 'lvXfmrSerialNo' },
    { 'title': 'Bushing Size', 'field': 'bushingSize' },
    { 'title': 'SCADA #', 'field': 'scadaSerialNo' },
    { 'title': 'Tracked #1', 'field': 'trackerSerialNo1' },
    { 'title': 'Wildlife Repellent Added?', 'field': 'wildlifeRepellentAdded' },
    { 'title': 'Wildlife Warning Label Applied?', 'field': 'wildlifeWarningLabelApplied' },
    { 'title': 'Notes', 'field': 'notes' },
    { 'title': 'MVPS Status', 'field': 'skidStatus' }
  ];
  dataFields: any[] = [...this.allDataFields];

  blockScheduleList: any[] = [];

  constructor(private ref: DynamicDialogRef,
    private projectService: ProjectService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private permissions: PermissionService) {
    this.projectId = this.config.data.projectId;
    this.blockScheduleList = this.config.data.blockScheduleList || [];
    this.dataFields = this.getVisibleDataFields();
  }

  private getVisibleDataFields(): any[] {
    if (this.permissions.currentProjectRole !== ProjectRole.INTEGRATOR) {
      return [...this.allDataFields];
    }

    return this.allDataFields.filter(field => !this.integratorHiddenFields.has(field.field));
  }

  downloadTemplate() {
    this.projectService.getProjectBlockSchedule(this.projectId, false).subscribe((res) => {
      // Generate and download Excel template based on selected columns
      res.forEach(x => {
        x.shipDate = x.shipDate != null ? new Date(x.shipDate) : null;
        x.arrivalDate = x.arrivalDate != null ? new Date(x.arrivalDate) : null;
        x.deliveryDate = x.deliveryDate != null ? new Date(x.deliveryDate) : null;
        x.estimatedDeliveryDate = x.estimatedDeliveryDate != null ? new Date(x.estimatedDeliveryDate) : null;
        x.appointmentTime = x.appointmentTime != null ? new Date(x.appointmentTime) : null;
      });
      this.generateAndDownloadTemplate(res);
    });
  }

  private generateAndDownloadTemplate(blockScheduleData: any[]) {
    // Prepare data for Excel export
    const excelData: any[] = [];
    const templateFields = this.getTemplateFields();

    // Add data rows - get corresponding values for each selected field
    blockScheduleData.forEach(item => {
      const row: any = {};
      templateFields.forEach(selectedField => {
        let value = '';

        // Map field names to actual property names in the data
        const fieldMapping: { [key: string]: string } = {
          'skidNo': 'tmeicSkidNo',
          'shipDate': 'shipDate',
          'arrivalDate': 'arrivalDate',
          'skidSerialNo': 'integratorSkidSerialNo',
          'customerSkidNumber': 'customerSkidNumber',
          'skidConfiguration': 'skidConfiguration',
          'billoflading': 'billoflading',
          'appointmentTime': 'appointmentTime',
          'overWeight': 'overWeight',
          'overDimension': 'overDimension',
          'logisticsComment': 'logisticsComment',
          'deliveryDate': 'deliveryDate',
          'shippingStatus': 'shippingStatus',
          'inv1SerialNo': 'inv1SerialNo',
          'inv2SerialNo': 'inv2SerialNo',
          'inv3SerialNo': 'inv3SerialNo',
          'inv4SerialNo': 'inv4SerialNo',
          'inv5SerialNo': 'inv5SerialNo',
          'inv6SerialNo': 'inv6SerialNo',
          'inv7SerialNo': 'inv7SerialNo',
          'inv1Igbt': 'inv1Igbt',
          'inv2Igbt': 'inv2Igbt',
          'inv3Igbt': 'inv3Igbt',
          'inv4Igbt': 'inv4Igbt',
          'inv5Igbt': 'inv5Igbt',
          'inv6Igbt': 'inv6Igbt',
          'inv7Igbt': 'inv7Igbt',
          'scu': 'scu',
          'dis': 'dis',
          'epanb': 'epanb',
          'dcFuses': 'dcFuses',
          'estimatedDeliveryDate': 'estimatedDeliveryDate',
          'mvXfmrDesign': 'mvXfmrDesign',
          'mvXfmrSerialNo': 'mvXfmrSerialNo',
          'lvXfmrSerialNo': 'lvXfmrSerialNo',
          'bushingSize': 'bushingSize',
          'scadaSerialNo': 'scadaSerialNo',
          'trackerSerialNo1': 'trackerSerialNo1',
          'wildlifeRepellentAdded': 'wildlifeRepellentAdded',
          'wildlifeWarningLabelApplied': 'wildlifeWarningLabelApplied',
          'notes': 'notes',
          'skidStatus': 'skidStatus'
        };

        const propertyName = fieldMapping[selectedField.field] || selectedField.field;
        const rawValue = item[propertyName];

        if (rawValue !== null && rawValue !== undefined) {
          if (rawValue instanceof Date) {
            if (selectedField.field === 'appointmentTime') {
              // Format as HH:MM (time only)
              const h = String(rawValue.getHours()).padStart(2, '0');
              const m = String(rawValue.getMinutes()).padStart(2, '0');
              value = `${h}:${m}`;
            } else {
              value = rawValue.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
            }
          } else if (typeof rawValue === 'boolean') {
            value = rawValue.toString();
          } else {
            value = rawValue.toString();
          }
        }

        // Use the title as the column header in Excel
        row[selectedField.title] = value;
      });
      excelData.push(row);
    });

    // Create a new workbook and worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'BlockSchedule Template');

    // Generate Excel file and download
    const fileName = `BlockSchedule_BulkUpdate_Template_${this.projectId}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  onFileSelect(event: any) {
    if (event.currentFiles && event.currentFiles.length > 0) {
      this.fileSelected = event.currentFiles[0];
    } else if (event.files && event.files.length > 0) {
      this.fileSelected = event.files[0];
    }
  }

  onFileUpload() {
    if (!this.fileSelected) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a file first'
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        // Read the Excel file
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Get the first worksheet
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];

        // Convert worksheet to JSON
        const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        if (jsonData.length === 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'The Excel file is empty'
          });
          return;
        }

        // Process and merge the Excel data with existing BlockSchedule records
        const mergeResult = this.mergeExcelDataWithExisting(jsonData);
        const blockScheduleUpdates = mergeResult.mergedResults;

        if (mergeResult.validationMessages.length > 0) {
          mergeResult.validationMessages.forEach(msg => {
            this.messageService.add({
              severity: 'warn',
              summary: 'Edit',
              detail: msg
            });
          });
          return;
        }

        // Send batch update to backend
        this.projectService.updateBlockScheduleBatch(blockScheduleUpdates).subscribe({
          next: (response) => {
            if (response && response.length > 0) {
              // Backend returned validation errors — data was NOT saved
              response.forEach(msg => {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Bulk Update Warning',
                  detail: msg
                });
              });
            } else {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Bulk update completed successfully. ${blockScheduleUpdates.length} record(s) updated.`
              });
              this.ref.close(true);
            }
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to update block schedule data'
            });
          }
        });

      } catch (error) {
        console.error('Error parsing Excel file:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to parse Excel file. Please ensure it is a valid Excel file.'
        });
      }
    };

    reader.onerror = (error) => {
      console.error('Error reading file:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to read the file'
      });
    };

    reader.readAsArrayBuffer(this.fileSelected);
  }

  private mergeExcelDataWithExisting(excelData: any[]): { mergedResults: any[]; validationMessages: string[] } {
    // Map Excel column headers back to database field names
    const reverseFieldMapping: { [key: string]: string } = {
      'TMEIC MVPS # ': 'tmeicSkidNo',
      'TMEIC Skid # ': 'tmeicSkidNo', // Legacy spreadsheet header
      'Shipping Date': 'shipDate',
      'Arrival Date': 'arrivalDate',
      'Integrator MVPS #': 'integratorSkidSerialNo',
      'Integrator Skid #': 'integratorSkidSerialNo', // Legacy spreadsheet header
      'Customer MVPS #': 'customerSkidNumber',
      'Customer Skid #': 'customerSkidNumber', // Legacy spreadsheet header
      'MVPS Configuration': 'skidConfiguration',
      'Skid Configuration': 'skidConfiguration', // Legacy spreadsheet header
      'Bill of lading': 'billoflading',
      'Appointment Time': 'appointmentTime',
      'Over Weight': 'overWeight',
      'Over Dimension': 'overDimension',
      'Logistics Comment': 'logisticsComment',
      'Delivery Date': 'deliveryDate',
      'Shipping Status': 'shippingStatus',
      'Inverter 1 Serial No': 'inv1SerialNo',
      'Inverter 2 Serial No': 'inv2SerialNo',
      'Inverter 3 Serial No': 'inv3SerialNo',
      'Inverter 4 Serial No': 'inv4SerialNo',
      'Inverter 5 Serial No': 'inv5SerialNo',
      'Inverter 6 Serial No': 'inv6SerialNo',
      'Inverter 7 Serial No': 'inv7SerialNo',
      'Inverter 1 IGBT': 'inv1Igbt',
      'Inverter 2 IGBT': 'inv2Igbt',
      'Inverter 3 IGBT': 'inv3Igbt',
      'Inverter 4 IGBT': 'inv4Igbt',
      'Inverter 5 IGBT': 'inv5Igbt',
      'Inverter 6 IGBT': 'inv6Igbt',
      'Inverter 7 IGBT': 'inv7Igbt',
      'SCU Installed?': 'scu',
      'DIS Installed?': 'dis',
      'EPANB Installed?': 'epanb',
      'DC Fuses Installed?': 'dcFuses',
      'Estimated Delivery Date': 'estimatedDeliveryDate',
      'MV Xfmr Design': 'mvXfmrDesign',
      'MV Xfmr #': 'mvXfmrSerialNo',
      'LV Xfmr #': 'lvXfmrSerialNo',
      'Bushing Size': 'bushingSize',
      'SCADA #': 'scadaSerialNo',
      'Tracked #1': 'trackerSerialNo1',

      'Wildlife Repellent Added?': 'wildlifeRepellentAdded',
      'Wildlife Warning Label Applied?': 'wildlifeWarningLabelApplied',
      'Notes': 'notes',
      'MVPS Status': 'skidStatus',
      'Skid Status': 'skidStatus' // Legacy spreadsheet header
    };

    const mergedResults: any[] = [];
    const validationMessages: string[] = [];

    excelData.forEach(row => {
      // Get TMEIC Skid # from Excel row to find existing record
      const tmeicSkidNoRaw = row['TMEIC MVPS # '] ?? row['TMEIC Skid # '];
      // Convert to number for comparison (Excel returns strings)
      const tmeicSkidNo = typeof tmeicSkidNoRaw === 'string' ? parseInt(tmeicSkidNoRaw, 10) : tmeicSkidNoRaw;

      // Find the existing block schedule record
      const existingRecord = this.blockScheduleList.find(
        block => block.tmeicSkidNo === tmeicSkidNo
      );

      if (!existingRecord) {
        console.warn(`No existing record found for TMEIC Skid #: ${tmeicSkidNo}`);
        console.warn('Available TMEIC Skid #s:', this.blockScheduleList.map(b => b.tmeicSkidNo));
        return;
      }

      // Clone the existing record to preserve all fields
      const mergedRecord = { ...existingRecord };

      // Update only the fields that are present in the Excel row
      Object.keys(row).forEach(excelColumn => {
        const dbField = reverseFieldMapping[excelColumn];
        if (dbField && dbField !== 'tmeicSkidNo') { // Don't update the key field
          let value = row[excelColumn];

          // Handle appointment time separately (time only with fixed date)
          if (dbField === 'appointmentTime') {
            if (value && value !== '') {
              // Value is HH:MM (from exported template) — parse directly
              const parts = String(value).split(':');
              if (parts.length >= 2) {
                const hours = String(parts[0]).padStart(2, '0');
                const minutes = String(parts[1]).padStart(2, '0');
                const seconds = parts.length >= 3 ? String(parts[2]).padStart(2, '0') : '00';
                mergedRecord[dbField] = `1900-01-01T${hours}:${minutes}:${seconds}`;
              }
            } else {
              mergedRecord[dbField] = null;
            }
          }
          // Handle date fields (full date)
          else if (['shipDate', 'arrivalDate', 'deliveryDate', 'estimatedDeliveryDate'].includes(dbField)) {
            if (value && value !== '') {
              const dateValue = new Date(value);
              if (!isNaN(dateValue.getTime())) {
                mergedRecord[dbField] = dateValue.toISOString();
              }
            } else {
              mergedRecord[dbField] = null;
            }
          }
          // Handle boolean fields
          else if (['overWeight', 'overDimension'].includes(dbField)) {
            mergedRecord[dbField] = value === 'true' || value === true || value === 'TRUE';
          }
          // Handle other fields
          else {
            mergedRecord[dbField] = value !== '' ? value : null;
          }
        }
      });

      // Convert all Date objects to ISO strings (including existing dates not updated from Excel)
      if (mergedRecord.shipDate instanceof Date) {
        mergedRecord.shipDate = mergedRecord.shipDate.toISOString();
      }
      if (mergedRecord.arrivalDate instanceof Date) {
        mergedRecord.arrivalDate = mergedRecord.arrivalDate.toISOString();
      }
      if (mergedRecord.deliveryDate instanceof Date) {
        mergedRecord.deliveryDate = mergedRecord.deliveryDate.toISOString();
      }
      if (mergedRecord.estimatedDeliveryDate instanceof Date) {
        mergedRecord.estimatedDeliveryDate = mergedRecord.estimatedDeliveryDate.toISOString();
      }
      if (mergedRecord.appointmentTime instanceof Date) {
        const date = mergedRecord.appointmentTime;
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        mergedRecord.appointmentTime = `1900-01-01T${hours}:${minutes}:${seconds}`;
      }

      const statusValidation = this.validateCompletedOrShippedRequirements(mergedRecord);
      if (!statusValidation.valid) {
        mergedRecord.skidStatus = this.normalizeSkidStatusValue(existingRecord.skidStatus);
        validationMessages.push(
          `MV Power Station # ${tmeicSkidNo}: ${statusValidation.messages.join(' ')} MV Power Station Status reverted to existing value.`
        );
      }

      const shippingValidation = this.validateShippingStatusRequirements(mergedRecord);
      if (!shippingValidation.valid) {
        mergedRecord.shippingStatus = existingRecord.shippingStatus ?? null;
        validationMessages.push(
          `MV Power Station # ${tmeicSkidNo}: ${shippingValidation.messages.join(' ')} Shipping Status reverted to existing value.`
        );
      }

      mergedResults.push(mergedRecord);
    });

    return { mergedResults, validationMessages };
  }

  private isCompletedLikeStatus(status?: string | null): boolean {
    const normalized = (status || '').trim().toLowerCase();
    return normalized === 'complete' || normalized === 'completed' || normalized === 'shipped';
  }

  private normalizeSkidStatusValue(status?: string | null): string | null {
    const trimmed = (status ?? '').trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  private getRequiredInverterCount(skidConfiguration?: string | null): number {
    if (!skidConfiguration) {
      return 0;
    }

    const match = skidConfiguration.trim().toUpperCase().match(/(\d+)/);
    if (!match) {
      return 0;
    }

    const count = Number(match[1]);
    if (Number.isNaN(count) || count < 0) {
      return 0;
    }

    return Math.min(count, 7);
  }

  private getMissingInverterSerials(record: any, requiredCount: number): number[] {
    const serials = [
      record.inv1SerialNo,
      record.inv2SerialNo,
      record.inv3SerialNo,
      record.inv4SerialNo,
      record.inv5SerialNo,
      record.inv6SerialNo,
      record.inv7SerialNo
    ];

    const missing: number[] = [];
    for (let i = 0; i < requiredCount; i++) {
      const value = serials[i];
      if (!value || !String(value).trim()) {
        missing.push(i + 1);
      }
    }

    return missing;
  }

  private validateShippingStatusRequirements(record: any): { valid: boolean; messages: string[] } {
    const status = (record.shippingStatus || '').trim();
    const messages: string[] = [];

    if (status !== '') {
      if (!String(record.billoflading ?? '').trim()) {
        messages.push('Bill of Lading is required.');
      }
      if (!record.appointmentTime) {
        messages.push('Appointment Time is required.');
      }
    }

    if (status === 'Delivered') {
      if (!record.deliveryDate) {
        messages.push('Delivery Date is required.');
      }
    }

    if (status === 'Returned') {
      if (!String(record.logisticsComment ?? '').trim()) {
        messages.push('Logistics Comment is required.');
      }
    }

    return { valid: messages.length === 0, messages };
  }

  private validateCompletedOrShippedRequirements(record: any): { valid: boolean; messages: string[] } {
    if (!this.isCompletedLikeStatus(record.skidStatus)) {
      return { valid: true, messages: [] };
    }

    const requiredCount = this.getRequiredInverterCount(record.skidConfiguration);
    const missingSerialIndexes = this.getMissingInverterSerials(record, requiredCount);
    const hasMvTransformerNumber = !!String(record.mvXfmrSerialNo ?? '').trim();
    const hasLvTransformerNumber = !!String(record.lvXfmrSerialNo ?? '').trim();

    const messages: string[] = [];

    if (missingSerialIndexes.length > 0) {
      const serialLabel = missingSerialIndexes.map(index => `INV${index}`).join(', ');
      messages.push(`Missing required inverter serial number(s): ${serialLabel}.`);
    }

    if (!hasMvTransformerNumber) {
      messages.push('MV Transformer Number is required.');
    }

    if (!hasLvTransformerNumber) {
      messages.push('LV Transformer Number is required.');
    }

    return { valid: messages.length === 0, messages };
  }

  private mapExcelDataToBlockSchedule(excelData: any[]): any[] {
    // Map Excel column headers back to database field names
    const reverseFieldMapping: { [key: string]: string } = {
      'TMEIC MVPS # ': 'tmeicSkidNo',
      'TMEIC Skid # ': 'tmeicSkidNo', // Legacy spreadsheet header
      'Shipping Date': 'shipDate',
      'Arrival Date': 'arrivalDate',
      'Integrator MVPS #': 'integratorSkidSerialNo',
      'Integrator Skid #': 'integratorSkidSerialNo', // Legacy spreadsheet header
      'Customer MVPS #': 'customerSkidNumber',
      'Customer Skid #': 'customerSkidNumber', // Legacy spreadsheet header
      'MVPS Configuration': 'skidConfiguration',
      'Skid Configuration': 'skidConfiguration', // Legacy spreadsheet header
      'Bill of lading': 'billoflading',
      'Appointment Time': 'appointmentTime',
      'Over Weight': 'overWeight',
      'Over Dimension': 'overDimension',
      'Logistics Comment': 'logisticsComment',
      'Delivery Date': 'deliveryDate',
      'Shipping Status': 'shippingStatus',
      'Inverter 1 Serial No': 'inv1SerialNo',
      'Inverter 2 Serial No': 'inv2SerialNo',
      'Inverter 3 Serial No': 'inv3SerialNo',
      'Inverter 4 Serial No': 'inv4SerialNo',
      'Inverter 5 Serial No': 'inv5SerialNo',
      'Inverter 6 Serial No': 'inv6SerialNo',
      'Inverter 7 Serial No': 'inv7SerialNo',
      'Inverter 1 IGBT': 'inv1Igbt',
      'Inverter 2 IGBT': 'inv2Igbt',
      'Inverter 3 IGBT': 'inv3Igbt',
      'Inverter 4 IGBT': 'inv4Igbt',
      'Inverter 5 IGBT': 'inv5Igbt',
      'Inverter 6 IGBT': 'inv6Igbt',
      'Inverter 7 IGBT': 'inv7Igbt',
      'SCU Installed?': 'scu',
      'DIS Installed?': 'dis',
      'EPANB Installed?': 'epanb',
      'DC Fuses Installed?': 'dcFuses',
      'Estimated Delivery Date': 'estimatedDeliveryDate',
      'MV Xfmr Design': 'mvXfmrDesign',
      'MV Xfmr #': 'mvXfmrSerialNo',
      'LV Xfmr #': 'lvXfmrSerialNo',
      'Bushing Size': 'bushingSize',
      'SCADA #': 'scadaSerialNo',
      'Tracked #1': 'trackerSerialNo1',

      'Wildlife Repellent Added?': 'wildlifeRepellentAdded',
      'Wildlife Warning Label Applied?': 'wildlifeWarningLabelApplied',
      'Notes': 'notes',
      'MVPS Status': 'skidStatus',
      'Skid Status': 'skidStatus' // Legacy spreadsheet header
    };

    return excelData.map(row => {
      const mappedRow: any = { projectId: this.projectId };

      // Map each Excel column to the correct database field
      Object.keys(row).forEach(excelColumn => {
        const dbField = reverseFieldMapping[excelColumn];
        if (dbField) {
          let value = row[excelColumn];

          // Handle appointment time separately (time only with fixed date)
          if (dbField === 'appointmentTime') {
            if (value && value !== '') {
              const dateValue = new Date(value);
              if (!isNaN(dateValue.getTime())) {
                const hours = String(dateValue.getHours()).padStart(2, '0');
                const minutes = String(dateValue.getMinutes()).padStart(2, '0');
                const seconds = String(dateValue.getSeconds()).padStart(2, '0');
                mappedRow[dbField] = `1900-01-01T${hours}:${minutes}:${seconds}`;
              }
            }
          }
          // Handle date fields (full date)
          else if (['shipDate', 'arrivalDate', 'deliveryDate', 'estimatedDeliveryDate'].includes(dbField)) {
            if (value && value !== '') {
              // Try to parse date string
              const dateValue = new Date(value);
              if (!isNaN(dateValue.getTime())) {
                mappedRow[dbField] = dateValue.toISOString();
              }
            }
          }
          // Handle boolean fields
          else if (['overWeight', 'overDimension'].includes(dbField)) {
            mappedRow[dbField] = value === 'true' || value === true || value === 'TRUE';
          }
          // Handle other fields
          else {
            mappedRow[dbField] = value !== '' ? value : null;
          }
        }
      });

      return mappedRow;
    });
  }

  onSelectionChange(event: any): void {
    const newValues: any[] = event.value || [];
    // Items newly added — append to end to preserve click order
    const added = newValues.filter(v => !this.selectedItems.some(s => s.field === v.field));
    // Keep existing order, remove deselected, then append newly added
    const selectedItems = [
      ...this.selectedItems.filter(s => newValues.some(v => v.field === s.field)),
      ...added
    ];

    this.selectedItems = this.normalizeSelectedFields(selectedItems);
  }

  private getTemplateFields(): any[] {
    this.selectedItems = this.normalizeSelectedFields(this.selectedItems);
    return this.selectedItems;
  }

  private normalizeSelectedFields(fields: any[]): any[] {
    const nonKeyFields = (fields || []).filter(field => field.field !== this.tmeicSkidField.field);
    return [this.tmeicSkidField, ...nonKeyFields];
  }

  onFileClear() {
    this.fileSelected = null;
  }

  cancel(): void {
    this.ref.close();
  }
}
